export const PORTAL_CONFIG_URL = 'ui/partner/portal_config';

export const portalConfigQueryKeys = {
  base: [PORTAL_CONFIG_URL],
};
